import React from 'react';
import { connect } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { signOut } from '../store/auth';


const Logout = (props) => {
    const history = useHistory();
    if (!props.auth || !props.auth.uid) return <Redirect to="/" />;

    return (
        
        <div className='container white'>
            <h5>Are you sure you want to log out?</h5>
            <div className="row">
            <br/>
                <button className="btn pink lighten-1 z-depth-0" onClick={props.logout}>Yes</button>
                <button className="btn pink lighten-1 z-depth-0" style={{marginLeft: 20}} onClick={history.goBack}>No</button>
            </div>
            <br/>
        </div>);
};

const mapStateToProps = (state) => ({
    auth: state.firebase.auth
})

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(signOut())
})

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
